"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformValue = void 0;
const config_1 = require("../../../config");
const METER_TO_INCH_CONST = 0.0254;
const METER_TO_FEET_CONST = 0.3048;
const METER_TO_YARD_CONST = 0.9144;
const METER_TO_MILE_CONST = 1609.344;
const METER_TO_KILO_CONST = 1000;
const METER_TO_METER_CONST = 1;
const METER_TO_DECI_CONST = 0.1;
const METER_TO_CENTI_CONST = 0.01;
const METER_TO_MILI_CONST = 0.001;
function transformValue(value, transformator) {
    var _a;
    let transformer;
    switch (transformator.type) {
        case 1 /* TO_INCH */:
            transformer = METER_TO_INCH_CONST;
            break;
        case 2 /* TO_FEET */:
            transformer = METER_TO_FEET_CONST;
            break;
        case 3 /* TO_YARD */:
            transformer = METER_TO_YARD_CONST;
            break;
        case 4 /* TO_MILE */:
            transformer = METER_TO_MILE_CONST;
            break;
        case 5 /* TO_KILO */:
            transformer = METER_TO_KILO_CONST;
            break;
        case 6 /* TO_METER */:
            transformer = METER_TO_METER_CONST;
            break;
        case 7 /* TO_DECI */:
            transformer = METER_TO_DECI_CONST;
            break;
        case 8 /* TO_CENTI */:
            transformer = METER_TO_CENTI_CONST;
            break;
        case 9 /* TO_MILI */:
            transformer = METER_TO_MILI_CONST;
            break;
        default: throw new Error("Unknown transformator type");
    }
    const scale = (_a = transformator.scale) !== null && _a !== void 0 ? _a : config_1.config.measurement.defaultScale;
    const transformedValue = value / transformer * 1 / scale;
    return transformedValue;
}
exports.transformValue = transformValue;
